/** Backend keys — keep aligned with app/services/page_access.py */

export const PAGE_KEYS = {
  opportunity: 'opportunity',
  campaigns: 'campaigns',
  clients: 'clients',
  contacts: 'contacts',
  tasks: 'tasks',
  products: 'products',
  balance: 'balance',
  invoices: 'invoices',
  inventory: 'inventory',
  kpis: 'kpis',
} as const;

export type PageKey = (typeof PAGE_KEYS)[keyof typeof PAGE_KEYS];

export type RoutePageAccess =
  | 'all'
  | 'hidden'
  | 'owner_only';

export function effectiveAccessForPage(
  pageAccessByEnterprise: Record<string, Record<string, string>> | undefined,
  enterpriseId: string | undefined,
  pageKey: PageKey,
): RoutePageAccess {
  if (!enterpriseId || !pageAccessByEnterprise) {
    return 'all';
  }
  const raw = pageAccessByEnterprise[enterpriseId]?.[pageKey];
  if (
    pageKey === PAGE_KEYS.opportunity ||
    pageKey === PAGE_KEYS.kpis ||
    pageKey === PAGE_KEYS.balance ||
    pageKey === PAGE_KEYS.invoices
  ) {
    if (raw === 'hidden') return 'hidden';
    if (raw === 'owner_only') return 'owner_only';
    return 'all';
  }
  if (raw === 'hidden') return 'hidden';
  return 'all';
}

/** Pathname (without basename) → page key for sidebar / guards */
export function pageKeyForPath(pathname: string): PageKey | null {
  if (pathname === '/' || pathname === '/opportunity') return PAGE_KEYS.opportunity;
  const map: Record<string, PageKey> = {
    '/kpis': PAGE_KEYS.kpis,
    '/campaigns': PAGE_KEYS.campaigns,
    '/clients': PAGE_KEYS.clients,
    '/contacts': PAGE_KEYS.contacts,
    '/tasks': PAGE_KEYS.tasks,
    '/products': PAGE_KEYS.products,
    '/balance': PAGE_KEYS.balance,
    '/invoices': PAGE_KEYS.invoices,
    '/inventory': PAGE_KEYS.inventory,
  };
  return map[pathname] ?? null;
}
